import { useRef, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import DropdownTooltip from '../../../common/textEllipsis/DropdownTooltip'

export const Label = ({ label, renderToolTipContent }) => {
  const ref = useRef()
  const [isShow, setIsShow] = useState(false)

  const onMouseEnter = () => {
    setIsShow(true)
  }

  const onMouseLeave = () => {
    setIsShow(false)
  }

  return (
    <div className="dFlex alignItemsCenter">
      <Element elementName="span" style={{ fontSize: 14 }}>
        <Translate value={label} className="fw600" />
      </Element>

      <Icon
        iconRef={ref}
        className="icon-info-circle"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{
          color: '#9C9C9C',
          fontSize: 16,
          cursor: 'unset',
          paddingLeft: 8,
        }}
      />
      {isShow && (
        <DropdownTooltip
          containerRef={ref}
          text={renderToolTipContent()}
          isI18n={false}
          isOpenTooltip={isShow}
          zIndexTooltip={1}
          tooltipMaxWidthByContent={false}
        />
      )}
    </div>
  )
}
